export default "__VITE_ASSET__Bn6Pe7rW__"